/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {ObservationModel, SelectModel} from '../../../../../../model'
import {getObservation} from '../../../../../../services'
import {deleteObservation} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ModalAddObservation} from '../modal/ModalAddObservations'
import Swal from 'sweetalert2'
import {getMasterService} from '../../../../../../../central/services'
import {useKhipu} from '../../../../../../../../hooks/useKhipu'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const getFormatDate = (fechaIn: any): FormattedDate | string => {
  if (!fechaIn) {
    return ''
  }
  let fechaActual = new Date(fechaIn)
  let año: Date | any = fechaActual.getFullYear()
  let mes: Date | any = fechaActual.getMonth() + 1
  let dia: Date | any = fechaActual.getDate()
  let hora: Date | any = fechaActual.getHours()
  let minutos: Date | any = fechaActual.getMinutes()
  let segundos: Date | any = fechaActual.getSeconds()

  // Formatear la salida si es necesario
  mes = mes < 10 ? '0' + mes : mes
  dia = dia < 10 ? '0' + dia : dia
  hora = hora < 10 ? '0' + hora : hora
  minutos = minutos < 10 ? '0' + minutos : minutos
  segundos = segundos < 10 ? '0' + segundos : segundos

  // Imprimir la fecha y hora
  return {fecha: dia + '/' + mes + '/' + año, tiempo: hora + ':' + minutos + ':' + segundos}
}
const TableObservationByInpsect: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    selectedOn,
    pagination,
    updateTable,
    clearTable,
    setUpdateTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()

  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailObservation, setDetailObservation] = useState<any>('')
  const [typeCategoria, setTypeCategoria] = useState<SelectModel[]>([])

  const handleClear = () => {
    setIdPermission('')
  }
  const getObservationList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getObservation(
        {mantenimientoInspeccionId: currentTabItem.idToEdit, ...searchValues},
        1,
      )
      if (!response.error) {
        const dataInfo = response.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const getTypeCategoriaList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'CategoriaObservacionLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))

      setTypeCategoria(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    getTypeCategoriaList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getObservationList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleEdit = (item: any) => {
    const filter = data.filter((detail) => detail.id === item.id)
    if (filter.length > 0) {
      setDetailObservation(filter[0])
      setIdPermission(item.id)
      setShowModalNew(true)
    }
  }

  const columns: Column<ObservationModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Categoría'
            name='categoria'
            data={typeCategoria}
            selecteable
          />
        ),
        accessor: 'categoriaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Código de observación'
            name='codigoObservacion'
            searcheable
          />
        ),
        accessor: 'codigoObservacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Descripción de observación'
            name='descripcionObservacion'
            searcheable
          />
        ),
        accessor: 'descripcionObservacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de detección'
            name='fechaDeteccion'
            dateable
          />
        ),
        accessor: 'fechaDeteccion',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaDeteccion
            ? getFormatDate(props.data[props.row.index].fechaDeteccion)
            : ''
          return <span>{dateCreation ? `${(dateCreation as FormattedDate).fecha}` : ''}</span>
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha planificada de cierre'
            name='fechaPlanificadaCierre'
            dateable
          />
        ),
        accessor: 'fechaPlanificadaCierre',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaPlanificadaCierre
            ? getFormatDate(props.data[props.row.index].fechaPlanificadaCierre)
            : ''
          return <span>{dateCreation ? `${(dateCreation as FormattedDate).fecha}` : ''}</span>
        },
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de cierre' name='fechaCierre' dateable />
        ),
        accessor: 'fechaCierre',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaCierre
            ? getFormatDate(props.data[props.row.index].fechaCierre)
            : ''
          return <span>{dateCreation ? `${(dateCreation as FormattedDate).fecha}` : ''}</span>
        },
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Estado' name='estadoObservacion' searcheable />
        ),
        accessor: 'estadoObservacionNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('OBSERVACION/EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleEdit(props.data[props.row.index])}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [data, typeCategoria, selectedOn],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)

        const {data: response} = await deleteObservation(selectedOn[0])
        if (!response.error) {
          getObservationList()
        }
        getObservationList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }
  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getObservationList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('OBSERVACION/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('OBSERVACION/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
            >
              Eliminar
            </button>
          )}
        </div>
        {isAllowed('OBSERVACION/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
        <ModalAddObservation
          show={showModalNew}
          setShow={setShowModalNew}
          getObservationList={getObservationList}
          detailObservation={detailObservation}
          idPermission={idPermission}
          setIdPermissionList={handleClear}
        />
      </KTCard>
    </>
  )
}

const TableObservationByInpsectWrapper = () => {
  return (
    <KTableProvider>
      <TableObservationByInpsect />
    </KTableProvider>
  )
}
export {TableObservationByInpsectWrapper}
